import { fetchRent, fetchRentSlug } from "../../services/rent";
import { fetchCity } from "../../services/city";
import { action, thunk, computed } from "easy-peasy";

export const rentModel = {
  rents: [],
  cities: [],
  city2: "все",
  rent: true,
  error: null,
  priceRange: [1, 499000],
  smallPriceRange: [1, 9999],
  areaRange: [1, 1000],
  noPhoto: false,
  index: null,
  oneRent: {},
  picIndex: 0,
  showingRentPic: computed((state) =>
    state.oneRent.media && state.oneRent.media.length
      ? state.oneRent.media[state.picIndex].url
      : null
  ),
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setCity: action((state, payload) => {
    state.cities = payload;
  }),
  setCityIndex: action((state, payload) => {
    state.city2 = payload;
  }),
  setRentOrSell: action((state, payload) => {
    state.rent = payload;
    if (!payload) {
      state.priceRange = [1, 100000000]
      state.smallPriceRange = [1, 500000]
    } else {
      state.priceRange = [1, 499000]
      state.smallPriceRange = [1, 9999]
    }
  }),
  setRent: action((state, payload) => {
    state.rents = payload;
  }),
  setPriceRange: action((state, payload) => {
    state.priceRange = payload;
  }),
  setSmallPriceRange: action((state, payload) => {
    state.smallPriceRange = payload;
  }),
  setAreaRange: action((state, payload) => {
    state.areaRange = payload;
  }),
  setNoPhoto: action((state, payload) => {
    state.noPhoto = payload;
  }),
  setIndex: action((state, payload) => {
    state.index = payload;
  }),
  setOneRent: action((state, payload) => {
    state.oneRent = payload;
  }),
  setPicIndex: action((state, payload) => {
    state.picIndex = payload;
  }),
  getRentSlug: thunk(async (actions, payload) => {
    try {
      const request = await fetchRentSlug(payload);
      if (request && !request.error && request.length > 0)
        actions.setOneRent(request[0]);
    } catch (err) {
      actions.setError(err);
    }
  }),
  getRent: thunk(async (actions, payload, helpers) => {
    try {
      const { rent } = helpers.getState();
      const { city2 } = helpers.getState();
      const { priceRange } = helpers.getState();
      const { smallPriceRange } = helpers.getState();
      const { areaRange } = helpers.getState();
      const { noPhoto } = helpers.getState();
      const opt = {
        cond: {
          rent: rent,
          "city.title": city2,
        },
        and: [
          [
            {
              smallPrice_gte: Math.round(smallPriceRange[0]),
            },
            {
              smallPrice_lte: Math.round(smallPriceRange[1]),
            },
          ],
          [
            {
              price_gte: Math.round(priceRange[0]),
            },
            {
              price_lte: Math.round(priceRange[1]),
            },
          ],
          [
            { area_gte: Math.round(areaRange[0]) },
            { area_lte: Math.round(areaRange[1]) },
          ],
        ],
      };
      if (noPhoto) opt.cond["media.size_gt"] = 0;
      if (city2 == "все") delete opt.cond["city.title"];
      if (payload) opt.cond["map_contains"] = payload;
      const request = await fetchRent(opt);
      if (request && !request.error) actions.setRent(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
  getCity: thunk(async (actions, payload) => {
    try {
      const request = await fetchCity(payload);
      if (request && !request.error) actions.setCity(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
};
